var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9766 9.34759L13.9766 7.82031L15.5038 7.82031L15.5038 9.34759L13.9766 9.34759Z",
    fill: "#929292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4492 20.0346L12.4492 9.34375L13.9765 9.34375L13.9765 20.0346L12.4492 20.0346Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5586 4.76562V15.4565H20.0858V4.76562H18.5586Z",
    fill: "#929292"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5039 18.5117L15.5039 16.9844L17.0312 16.9844L17.0312 18.5117L15.5039 18.5117Z",
    fill: "#929292"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5039 7.81634L15.5039 6.28906L17.0312 6.28906L17.0312 7.81634L15.5039 7.81634Z",
    fill: "#929292"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0313 16.9804L17.0312 15.4531L18.5585 15.4531L18.5585 16.9804L17.0313 16.9804Z",
    fill: "#929292"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0313 6.2929L17.0312 4.76562L18.5585 4.76562L18.5585 6.2929L17.0313 6.2929Z",
    fill: "#929292"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39453 9.34759L9.39453 7.82031L10.9218 7.82031L10.9218 9.34759L9.39453 9.34759Z",
    fill: "#929292"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86719 20.0346L7.86719 9.34375L9.39445 9.34375L9.39445 20.0346L7.86719 20.0346Z",
    fill: "#929292"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9219 7.81634L10.9219 6.28906L12.4492 6.28906L12.4492 7.81634L10.9219 7.81634Z",
    fill: "#929292"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4492 6.2929L12.4492 4.76562L13.9765 4.76562L13.9765 6.2929L12.4492 6.2929Z",
    fill: "#929292"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 9.34759L4.8125 7.82031L6.33978 7.82031L6.33978 9.34759L4.8125 9.34759Z",
    fill: "#929292"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28516 20.0346L3.28516 9.34375L4.81242 9.34375L4.81242 20.0346L3.28516 20.0346Z",
    fill: "#929292"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33984 7.81634L6.33984 6.28906L7.86712 6.28906L7.86712 7.81634L6.33984 7.81634Z",
    fill: "#929292"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86719 6.2929L7.86719 4.76562L9.39446 4.76562L9.39446 6.2929L7.86719 6.2929Z",
    fill: "#929292"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9766 20.0351L13.9766 18.5078L15.5038 18.5078L15.5038 20.0351L13.9766 20.0351Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuests);
export default __webpack_public_path__ + "static/media/quests.8e7fae3e88f925348e9e27698b8d10ab.svg";
export { ForwardRef as ReactComponent };